import { createStyles } from 'antd-style';

import {
  INPUT_BASE_HEIGHT,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../../theme';
import {
  responsiveMdVsLg,
  responsiveSmVsMd,
} from '../../../styles/responsiveMixins';
import { absoluteMiddleToRight, spaceBetween } from '../../../styles/mixins';
import { FA_SELECTOR } from '../../../styles/variables';

export const useNewShipmentElementsStyles = createStyles(
  ({ token }, { twoLines } = {}) => ({
    newShipmentTopControls: {
      display: 'flex',

      '> *': {
        ...spaceBetween(ThemeSpaces.SPACE_NORM_20),
      },

      '.ant-btn': {
        width: 80,
      },
      '.ant-btn.ant-btn-primary': {
        width: 150,
      },
    },
    redLink: {
      fontWeight: 700,
      color: `${token.colorPrimary} !important`,
      lineHeight: 1,

      [`@media (min-width: ${token.screenMDMin}px)`]: {
        fontSize: token.fontSize,
      },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: token.fontSizeSM,
      },

      '> *': {
        textDecoration: 'underline',
      },
    },
    titleCancelLink: {
      ...absoluteMiddleToRight(),
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
    newShipmentLinkAboveFirstSection: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,

      ...responsiveSmVsMd(
        {
          left: ThemeSpaces.SPACE_NORM,
          top: 4,
        },
        {
          left: ThemeSpaces.SPACE_NORM_20,
          top: 4,
        }
      ),
    },
    newShipmentBottomControls: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: 0,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          '> .ant-btn.ant-btn-primary': {
            width: 240,
          },
        },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          '> .ant-btn.ant-btn-primary': {
            width: 120,
          },
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        '> .ant-btn.ant-btn-primary': {
          width: 110,
        },
      },

      '> .ant-btn': {
        height: INPUT_BASE_HEIGHT,

        ...responsiveSmVsMd(
          { ...spaceBetween(ThemeSpaces.SPACE_NORM) },
          { ...spaceBetween(ThemeSpaces.SPACE_NORM_20) }
        ),
      },

      '.NewShipmentPackageListForm &': {
        '> .ant-btn.ant-btn-primary': {
          ...responsiveSmVsMd(
            { width: 'auto', flex: 1 },
            { width: 200, flex: 'initial' }
          ),
        },
      },
    },
    newShipmentCardBody: {
      ...responsiveSmVsMd(
        { padding: `${token.paddingMD}px ${ThemeSpaces.SPACE_NORM}px` },
        {
          padding: `${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_20}px`,
        }
      ),

      [`@media (max-width: ${token.screenXSMax}px)`]: {
        '#NewShipmentPage &': {
          padding: `${token.paddingMD}px ${ThemeSpaces.SPACE_NORM}px`,

          '&.ConfigurableCard-Body': {
            padding: 0,
            paddingTop: token.paddingMD,
            backgroundColor: 'transparent',
            borderWidth: 0,
            boxShadow: 'none',
          },
        },
      },
      '&.ShipperSpecificCard .ant-form-item-horizontal': {
        marginBottom: 10,
      },
    },
    jobLocationCardSection: {
      paddingTop: ThemeSpaces.SPACE_NORM,

      '&:first-child': {
        paddingTop: 0,
      },
      [`&:last-child .${twoLines}`]: {
        display: 'none',
      },

      [`.${twoLines}`]: {
        ...responsiveSmVsMd(
          {
            marginLeft: -ThemeSpaces.SPACE_NORM,
            marginRight: -ThemeSpaces.SPACE_NORM,
          },
          { marginLeft: 0, marginRight: 0 }
        ),
      },
    },
    jobLocationCardSectionHeader: {
      ...responsiveMdVsLg(
        { marginBottom: ThemeSpaces.SPACE_NORM },
        { marginBottom: ThemeSpaces.SPACE_NORM0_5 }
      ),
    },
    jobLocationCardSectionTitle: {
      textTransform: 'uppercase',
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      fontWeight: 'bold',
      color: ThemeColors.COLOR_GREY_BLUISH3,
      lineHeight: 1,

      '& + *': {
        color: token.colorPrimary,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        fontWeight: 500,

        [FA_SELECTOR]: {
          fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
        },
      },
    },
    jobLocationCardSectionBody: {
      paddingBottom: ThemeSpaces.SPACE_NORM_15,

      '.JobLocationCard-Section:last-child &': {
        paddingBottom: 0,
      },

      '&.size-tiny': {
        marginTop: -token.marginXS,
        paddingBottom: ThemeSpaces.SPACE_NORM0_5,
      },

      '&& > *, && > .ant-row.ant-form-item': {
        ...spaceBetween(ThemeSpaces.SPACE_NORM, 'vertical'),

        '> *': {
          marginBottom: 0,
        },
      },
      '> .ant-row': {
        marginBottom: 0,
        '&:last-child': {
          marginBottom: -ThemeSpaces.SPACE_NORM,
        },

        '> *': {
          marginBottom: ThemeSpaces.SPACE_NORM,
        },
      },
    },
  })
);
